export default __webpack_public_path__ + "static/media/smoke.6fe2a041.svg";